import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useFetch from '@/hooks/pure/useFetch';

const AgentDetailRedirection = () => {
  const wc = useWorkspaceRouter();
  const { agent_alias } = useParams();

  const handleRoute = useCallback(async () => {
    if (!agent_alias) return;

    wc.push('/agents', {
      replace: true,
    });
  }, [wc, agent_alias]);

  useFetch(handleRoute);

  return <></>;
};

export default AgentDetailRedirection;
